/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { name, last_name, mother_last_name, date_of_birth, email, phone, doctor_id },
} = checkout;

const validations = Yup.object().shape({
  [name.name]: Yup.string().required(name.errorMsg),
  [last_name.name]: Yup.string().required(last_name.errorMsg),
  [mother_last_name.name]: Yup.string().required(mother_last_name.errorMsg),
    [doctor_id.name]: Yup.number().required(doctor_id.errorMsg).positive(doctor_id.invalidMsg),
});

export default validations;
